export default __webpack_public_path__ + "media/images/ad_landing_page/Mattel-a78102fb38f3d011d54522f79b8042d5.png";